function formatIntegerPart(integerPart) {
  return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatTradePrice(value) {
  if (value === null || value === undefined) return "-";

  const rawValue = String(value).trim();
  if (!rawValue) return "-";

  const sanitizedValue = rawValue.replace(/,/g, "");
  const matchedNumber = sanitizedValue.match(/^([+-]?)(\d+)(?:\.(\d+))?$/);

  if (matchedNumber) {
    const [, sign, integerPart, fractionalPart = ""] = matchedNumber;
    const trimmedFractionalPart = fractionalPart.replace(/0+$/, "");
    const formattedIntegerPart = formatIntegerPart(integerPart);
    const formattedValue = trimmedFractionalPart
      ? `${formattedIntegerPart}.${trimmedFractionalPart}`
      : formattedIntegerPart;

    if (formattedValue === "0") return "$0";
    return sign === "-" ? `-$${formattedValue}` : `$${formattedValue}`;
  }

  const numericValue = Number(sanitizedValue);
  if (!Number.isFinite(numericValue)) return "-";

  const formattedValue = Math.abs(numericValue).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20,
  });

  return numericValue < 0 ? `-$${formattedValue}` : `$${formattedValue}`;
}
